import { type JsonDataItem } from '@g2u/ui-kit';
import { baseQuery } from '../baseQuery';

export const getInventory = async ({ queryKey }: JsonDataItem) => {
  const serviceId = queryKey[2] ? `&service_id=${queryKey[2]}` : '';
  const { data } = await baseQuery(`inventory?type=${queryKey[1]}${serviceId}&per_page=9999`);

  return data;
};
